import { Col, Container, GridThemeProvider, Row } from '@dbi-tools/ui-kit';
import { FormCheckboxField, FormInputField } from '@dbi-tools/ui-kit/lib/form';
import React from 'react';
import { RadioGroup } from 'react-uforms';

import { GridBreakpointsArray, GridBreakpointsArrayType, Question } from '../../types';
import Control from '../control';
import { IconsContainerStyled, PinterestContainerStyled } from './question.layout.styled';

const scrollToRef = (id: string) => {
  if (typeof window !== 'undefined') {
    document.getElementById(id).scrollIntoView(true);
  }
};

const QuestionLayout: React.FC<{
  question: Question;
}> = ({ question }) => {
  const generateMedia = (items: { [key in GridBreakpointsArrayType]?: number }, gridColumns: number) => {
    const media = {};
    GridBreakpointsArray.forEach((v) => {
      const col = v === 'xs' ? 'col' : v;
      media[col] = items[v] ? gridColumns / items[v] : null;
    });
    return media;
  };
  const gridColumns = question?.metadata?.grid?.items ? Math.max(...Object.values(question?.metadata?.grid?.items)) : 1;
  const media = question?.metadata?.grid?.items && generateMedia(question?.metadata?.grid?.items, gridColumns);
  const padding = question?.metadata?.grid?.padding;
  const renderOptions = (addCoulmns = true) => {
    if (!question.options) {
      return;
    }
    return (
      <RadioGroup name={question.name}>
        {question.options.map((option) =>
          addCoulmns ? (
            <Col key={option.id} {...media}>
              <Control question={question} option={option} />
            </Col>
          ) : (
            <Control key={option.id} question={question} option={option} />
          ),
        )}
      </RadioGroup>
    );
  };

  if (question.type !== 'options') {
    //questions with user entered value
    //can be moved in separate component
    switch (question.type) {
      case 'email':
        return (
          <FormInputField
            type="email"
            onClick={() => scrollToRef(question.name)}
            id={question.name}
            name={question.name}
            placeholder={question.placeholderText}
            label={question.question}
            mb={15}
          />
        );
      case 'text':
        return (
          <FormInputField
            onClick={() => scrollToRef(question.name)}
            label={question.question}
            type="text"
            id={question.name}
            name={question.name}
            mb={15}
            placeholder={question.placeholderText}
          />
        );
      case 'checkbox':
        return (
          <FormCheckboxField
            color="white"
            label={question.question}
            measure="md"
            name={question.name}
            id={question.name}
            onValue={1}
            offValue={0}
            required={false}
          />
        );
    }
  } else {
    //questions with predefined values (options)
    switch (question.layout) {
      case 'pinterest':
        return <PinterestContainerStyled>{renderOptions(false)}</PinterestContainerStyled>;
      case 'icons-grid':
        return (
          <GridThemeProvider
            gridTheme={{
              gridColumns: gridColumns,
              breakpoints: { ...question?.metadata?.grid?.breakpoints },
              row: {
                padding: padding || 15,
              },
              col: {
                padding: padding || 15,
              },
              container: {
                padding: padding || 15,
                maxWidth: { ...question?.metadata?.grid?.container?.width },
              },
            }}
          >
            <IconsContainerStyled>
              <Row>{renderOptions()}</Row>
            </IconsContainerStyled>
          </GridThemeProvider>
        );
      case 'grid':
        return (
          <GridThemeProvider
            gridTheme={{
              gridColumns: gridColumns,
              breakpoints: { ...question?.metadata?.grid?.breakpoints },
              row: {
                padding: padding || 15,
              },
              col: {
                padding: padding || 15,
              },
              container: {
                padding: padding || 15,
                maxWidth: { ...question?.metadata?.grid?.container?.width },
              },
            }}
          >
            {question?.metadata?.grid?.container?.show ? (
              <Container>
                <Row justifyContent={question?.metadata?.grid?.row?.justifyContent}>{renderOptions()}</Row>
              </Container>
            ) : (
              <Row justifyContent={question?.metadata?.grid?.row?.justifyContent}>{renderOptions()}</Row>
            )}
          </GridThemeProvider>
        );
    }
  }
};

export default QuestionLayout;
